import { SENHA_MAX_BYTES, SENHA_MIN } from "@zaphub/types";
import { cn } from "@zaphub/ui";
import { Check, Circle } from "lucide-react";

/** Régua de marcas que acende conforme a senha cresce + requisitos sempre visíveis. */
export function RequisitosSenha({ senha }: { senha: string }) {
  const bytes = new TextEncoder().encode(senha).length;
  const requisitos = [
    { ok: senha.length >= SENHA_MIN, texto: `Pelo menos ${SENHA_MIN} caracteres` },
    { ok: bytes <= SENHA_MAX_BYTES, texto: `No máximo ${SENHA_MAX_BYTES} caracteres` },
  ];
  const acesas = Math.min(SENHA_MIN, senha.length);
  return (
    <div className="grid gap-2">
      <div aria-hidden="true" className="flex gap-1">
        {Array.from({ length: SENHA_MIN }, (_, i) => (
          <span
            key={i}
            className={cn("h-1.5 flex-1 rounded-sm bg-muted transition-colors", i < acesas && "bg-primary")}
          />
        ))}
      </div>
      <ul className="grid gap-1" aria-label="Requisitos da senha">
        {requisitos.map((r) => (
          <li
            key={r.texto}
            className={cn("flex items-center gap-1.5 text-xs", r.ok ? "text-primary" : "text-muted-foreground")}
          >
            {r.ok ? <Check className="size-3.5" aria-hidden="true" /> : <Circle className="size-3.5" aria-hidden="true" />}
            <span>{r.texto}</span>
            <span className="sr-only">{r.ok ? "(atendido)" : "(pendente)"}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
